<div class="order-notif-wrapper">

  <button
    class="order-icon-btn"
    (click)="toggleDropdown($event)"
  >
    <nb-icon icon="shopping-bag-outline"></nb-icon>

    <span
      class="badge"
      *ngIf="unreadCount > 0"
    >
      {{ unreadCount > 99 ? '99+' : unreadCount }}
    </span>
  </button>


  <div
    class="order-dropdown"
    *ngIf="isOpen"
  >

    <!-- Header -->
    <div class="order-dropdown-header">

      <span>Orders</span>

      <small
        *ngIf="unreadCount > 0"
        class="unread-label"
      >
        {{ unreadCount }} new
      </small>

    </div>


    <!-- No orders -->
    <div
      class="empty-state"
      *ngIf="orders.length === 0"
    >
      <nb-icon icon="shopping-bag-outline"></nb-icon>
      <p>No orders yet</p>
    </div>


    <!-- Order list -->
    <div
      class="order-list"
      *ngIf="orders.length > 0"
    >

      <div
        class="order-row"
        *ngFor="let order of orders"
        (click)="openOrder(order, $event)"
        [class.unread]="!order.seen"
      >

        <!-- Left side -->
        <div class="order-info">

          <!-- Order number -->
          <div class="order-name">
            #{{ order.orderNumber }}
          </div>


          <!-- Customer details -->
          <div class="order-details">

            <div class="order-detail">
              <span class="order-detail-label">
                Customer:
              </span>

              <span class="order-detail-value">
                {{ order.customerName }}
              </span>
            </div>


            <div class="order-detail">
              <span class="order-detail-label">
                Phone:
              </span>

              <span class="order-detail-value">
                {{ order.customerPhone || 'N/A' }}
              </span>
            </div>


            <div class="order-detail">
              <span class="order-detail-label">
                Total Fare:
              </span>

              <span class="order-detail-value order-amount">
                ₹{{ order.amount }}
              </span>
            </div>

          </div>

        </div>


        <!-- Right side -->
        <div class="meta">

          <span class="time">
            {{ getTimeLabel(order.createdAt) }}
          </span>

          <span
            class="status"
            [ngClass]="order.status?.toLowerCase()"
          >
            {{ order.status }}
          </span>

        </div>

      </div>

    </div>

  </div>

</div>